import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconCalendarDate2 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d="M21.000,24.000 L1.000,24.000 C0.447,24.000 -0.000,23.552 -0.000,23.000 L-0.000,3.000 C-0.000,2.448 0.447,2.000 1.000,2.000 L6.000,2.000 L6.000,1.000 C6.000,0.448 6.447,0.000 7.000,0.000 C7.553,0.000 8.000,0.448 8.000,1.000 L8.000,2.000 L14.000,2.000 L14.000,1.000 C14.000,0.448 14.447,0.000 15.000,0.000 C15.553,0.000 16.000,0.448 16.000,1.000 L16.000,2.000 L21.000,2.000 C21.553,2.000 22.000,2.448 22.000,3.000 L22.000,23.000 C22.000,23.552 21.553,24.000 21.000,24.000 ZM20.000,4.000 L16.000,4.000 C16.000,4.552 15.553,5.000 15.000,5.000 C14.447,5.000 14.000,4.552 14.000,4.000 L8.000,4.000 C8.000,4.552 7.553,5.000 7.000,5.000 C6.447,5.000 6.000,4.552 6.000,4.000 L2.000,4.000 L2.000,6.000 L20.000,6.000 L20.000,4.000 ZM20.000,8.000 L2.000,8.000 L2.000,22.000 L20.000,22.000 L20.000,8.000 ZM7.293,10.293 C7.579,10.007 8.009,9.922 8.383,10.076 C8.757,10.231 9.000,10.596 9.000,11.000 L9.000,19.000 C9.000,19.552 8.553,20.000 8.000,20.000 C7.447,20.000 7.000,19.552 7.000,19.000 L7.000,13.414 L6.707,13.707 C6.316,14.098 5.684,14.098 5.293,13.707 C4.902,13.316 4.902,12.684 5.293,12.293 L7.293,10.293 ZM12.000,10.000 L16.000,10.000 C16.553,10.000 17.000,10.448 17.000,11.000 C17.000,11.552 16.553,12.000 16.000,12.000 L13.000,12.000 L13.000,13.000 L14.042,13.000 C14.932,13.000 17.000,13.357 17.000,16.667 C17.000,19.675 14.989,20.000 14.125,20.000 C12.958,20.000 11.000,19.611 11.000,17.000 C11.000,16.448 11.447,16.000 12.000,16.000 C12.553,16.000 13.000,16.448 13.000,17.000 C13.000,17.675 13.048,18.000 14.125,18.000 C14.575,18.000 15.000,18.000 15.000,16.667 C15.000,15.000 14.400,15.000 14.042,15.000 L12.000,15.000 C11.447,15.000 11.000,14.552 11.000,14.000 L11.000,11.000 C11.000,10.448 11.447,10.000 12.000,10.000 Z"
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconCalendarDate2.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
